import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { FiHome, FiLayers, FiShoppingBag, FiBox, FiUser } from "react-icons/fi";
import { useTranslation } from "../hooks/useTranslation";
import SidebarIconHome from "../images/icon/pkicon-home.png";
import SidebarIconGacha from "../images/icon/pkicon-gacha.png";
import SidebarIconMarketplace from "../images/icon/pkicon-marketplace.png";
import SidebarIconBuypack from "../images/icon/pkicon-vault.png";
import SidebarIconProfile from "../images/icon/pkicon-profile.png";

export default function MobileNavbar() {
    const location = useLocation();
    const { t } = useTranslation();

    const navItems = [
        { path: "/main", label: t("header.home"), iconType: "image", icon: SidebarIconHome },
        { path: "/gacha", label: t("header.gacha"), iconType: "image", icon: SidebarIconGacha },
        { path: "/marketplace", label: t("header.marketplace"), iconType: "image", icon: SidebarIconMarketplace },
        // { path: "/vault", label: t("library.title"), iconType: "image", icon: SidebarIconBuypack },
        { path: "/profile", label: t("header.profile"), iconType: "image", icon: SidebarIconProfile },
    ];

    return (
        <div
            style={{
                position: "fixed",
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 43,
                padding: "10px 10px 25px 10px", // Extra padding for safe area on iPhone
                background: "linear-gradient(to top, rgba(10, 10, 10, 0.95), rgba(10, 10, 10, 0.85))",
                backdropFilter: "blur(15px)",
                borderTop: "1px solid rgba(255, 255, 255, 0.08)",
                borderLeft: "1px solid rgba(255, 255, 255, 0.05)",
                borderRight: "1px solid rgba(255, 255, 255, 0.05)",
                borderRadius: "24px 24px 0 0",
                boxShadow: "0 -10px 25px rgba(0, 0, 0, 0.5)",
            }}
        >
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    maxWidth: "500px",
                    margin: "0 auto",
                    position: "relative",
                }}
            >
                {navItems.map((item) => {
                    const isActive = location.pathname.includes(item.path);

                    return (
                        <Link
                            key={item.path}
                            to={item.path}
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                textDecoration: "none",
                                flex: 1,
                                position: "relative",
                                padding: "8px 0",
                                zIndex: 2,
                            }}
                        >
                            {isActive && (
                                <motion.div
                                    layoutId="nav_active"
                                    transition={{ type: "spring", stiffness: 350, damping: 30 }}
                                    style={{
                                        position: "absolute",
                                        inset: "4px 8px",
                                        background: "linear-gradient(135deg, rgba(133, 114, 195, 0.25) 0%, rgba(31, 19, 70, 0.45) 100%)",
                                        border: "1px solid rgba(133, 114, 195, 0.3)",
                                        borderRadius: "16px",
                                        zIndex: -1,
                                    }}
                                />
                            )}

                            <img
                                src={item.icon}
                                alt=""
                                style={{
                                    width: "30px",
                                    opacity: isActive ? 1 : 0.7,
                                    filter: isActive ? "drop-shadow(0 0 8px rgba(133, 114, 195, 0.6))" : "none",
                                    transition: "transform, opacity, background-color, border-color, color 0.3s ease",
                                }}
                            />

                            <span
                                style={{
                                    fontSize: '12px',
                                    fontWeight: isActive ? 600 : 500,
                                    color: isActive ? "#fff" : "rgba(255, 255, 255, 0.45)",
                                    transition: "color 0.3s ease",
                                }}
                            >
                                {item.label}
                            </span>
                        </Link>
                    );
                })}
            </div>
        </div>
    );
}
